var _style, _rect, _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 32.31",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "cancelledclaim"
  }, "Cancelled Claim Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "cancelledclaim"
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    .claimCancelled1{fill:none;}.claimCancelled2,.claimCancelled3,.claimCancelled9{fill:#2f7bf5;}.claimCancelled3{fill-opacity:0.52;}.claimCancelled4{fill:#1f58b7;}.claimCancelled5,.claimCancelled7{fill:#2058b1;}.claimCancelled5,.claimCancelled6{fill-rule:evenodd;}.claimCancelled6{fill:#73acf7;}.claimCancelled8{fill:#225dbb;}.claimCancelled9{fill-opacity:0.21;}.claimCancelled10{fill:#bf311c;}\r\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "claimCancelled1",
    x: -895.63,
    y: -303.06,
    width: 1280,
    height: 1040
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled2",
    d: "M30.77,30.69a.53.53,0,1,1,.53-.53A.54.54,0,0,1,30.77,30.69Zm0-.85a.32.32,0,0,0-.32.32.32.32,0,1,0,.63,0A.31.31,0,0,0,30.77,29.84Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "claimCancelled3",
    cx: 15.02,
    cy: 17.39,
    r: 0.96
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled4",
    d: "M21.89,15h1.64a.33.33,0,0,0,0-.65H21.89a2.08,2.08,0,0,1-2.07-2.08V10.59a.32.32,0,0,0-.33-.32.32.32,0,0,0-.32.32v1.63A2.73,2.73,0,0,0,21.89,15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled3",
    d: "M21.19,22.39h-6.6a.86.86,0,1,1,0-1.7h6.6a.86.86,0,1,1,0,1.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled5",
    d: "M12.93,1.72a.2.2,0,0,0-.2.2v.47a.2.2,0,0,0,.4,0V1.92a.2.2,0,0,0-.2-.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled5",
    d: "M12.4,1.24h-.47a.21.21,0,0,0-.21.21.2.2,0,0,0,.21.2h.47a.2.2,0,0,0,.2-.2.2.2,0,0,0-.2-.21"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled5",
    d: "M12.93.27a.2.2,0,0,0-.2.2V.94a.2.2,0,1,0,.4,0V.47a.2.2,0,0,0-.2-.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled5",
    d: "M13.93,1.21h-.47a.2.2,0,0,0-.2.2.2.2,0,0,0,.2.21h.47a.21.21,0,0,0,.21-.21.2.2,0,0,0-.21-.2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled5",
    d: "M33.32,23.88a.34.34,0,0,0-.32.35V25a.33.33,0,0,0,.32.34.33.33,0,0,0,.32-.34v-.8a.34.34,0,0,0-.32-.35",
    "data-name": "Fill-6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled5",
    d: "M32.44,23h-.8a.32.32,0,1,0,0,.64h.8a.32.32,0,1,0,0-.64",
    "data-name": "Fill-7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled5",
    d: "M33.32,21.33a.33.33,0,0,0-.32.34v.8a.34.34,0,0,0,.32.35.34.34,0,0,0,.32-.35v-.8a.33.33,0,0,0-.32-.34",
    "data-name": "Fill-8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled5",
    d: "M35,23h-.8a.32.32,0,1,0,0,.64H35A.32.32,0,1,0,35,23",
    "data-name": "Fill-9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled5",
    d: "M2.11,16S2.4,18,0,18c0,0,2,0,2,1.89A2.28,2.28,0,0,1,4.06,18s-1.58.36-1.95-2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled6",
    d: "M30.83,2.39s.29,2-2.09,1.95c0,0,2,0,2,1.88a2.27,2.27,0,0,1,2.06-1.79s-1.59.35-2-2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled6",
    d: "M5.38,27.5a1,1,0,0,1-1.1,1.08,1,1,0,0,1,1,1.05,1.24,1.24,0,0,1,1.08-1s-.83.2-1-1.13"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled5",
    d: "M5.36,8.14a.57.57,0,0,1-.66.65s.65,0,.63.62A.74.74,0,0,1,6,8.82s-.5.11-.62-.68"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled7",
    d: "M23.43,1.54a.64.64,0,1,1,0-1.27.63.63,0,0,1,.63.63A.63.63,0,0,1,23.43,1.54Zm0-1.06a.43.43,0,1,0,.42.42A.42.42,0,0,0,23.43.48Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled8",
    d: "M2.47,4.31A.54.54,0,1,1,3,3.78.53.53,0,0,1,2.47,4.31Zm0-.85a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32.33.33,0,0,0,.32-.32A.32.32,0,0,0,2.47,3.46Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled8",
    d: "M35.45,14.1a.54.54,0,1,1,.53-.54A.54.54,0,0,1,35.45,14.1Zm0-.86a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32.32.32,0,0,0,.32-.32A.33.33,0,0,0,35.45,13.24Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled3",
    d: "M22.08,24.41a1,1,0,0,0-.89-.53h-6.6a.86.86,0,1,0,0,1.7h5.79A4.51,4.51,0,0,1,22.08,24.41Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled9",
    d: "M15.68,9H12.47a1.81,1.81,0,0,0-1.81,1.81v17a1.81,1.81,0,0,0,1.81,1.81h2.42a4,4,0,0,1-2-3.55V13.27A4.69,4.69,0,0,1,15.68,9Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled4",
    d: "M19.27,29.63h-6.8a1.81,1.81,0,0,1-1.81-1.81v-17A1.81,1.81,0,0,1,12.47,9H23.32a1.81,1.81,0,0,1,1.81,1.81V24.31a4.48,4.48,0,0,1,1.06.5v-14a2.87,2.87,0,0,0-2.87-2.87H12.47A2.86,2.86,0,0,0,9.6,10.8v17a2.87,2.87,0,0,0,2.87,2.87h7.18A4.32,4.32,0,0,1,19.27,29.63Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelled10",
    d: "M26.28,26.09h0l0,0a3.47,3.47,0,0,0-2.4-1A3.51,3.51,0,0,0,21.27,31l0,0h0a3.48,3.48,0,0,0,2.52,1.07,3.51,3.51,0,0,0,3.51-3.51A3.48,3.48,0,0,0,26.28,26.09Zm.2,2.52a2.64,2.64,0,0,1-2.64,2.64,2.69,2.69,0,0,1-1.6-.53l3.7-3.7A2.61,2.61,0,0,1,26.48,28.61ZM23.84,26a2.65,2.65,0,0,1,1.47.45l-3.66,3.66a2.55,2.55,0,0,1-.45-1.47A2.64,2.64,0,0,1,23.84,26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimCancelled);
export default __webpack_public_path__ + "static/media/claim-cancelled.412d30a2d7bac80df35fa95b7d0a6056.svg";
export { ForwardRef as ReactComponent };